<script>
import Payment from "./Payment/Index";
import Wirecard from "./Wirecard";
import Success from "./Success";
import CouponCard from "./CouponCard";
import Error from "./Error";

import orderMixin from "@/mixins/orderMixin";
import scrollMixin from "@/mixins/scrollMixin";

import { mapActions } from "vuex";

export default {
  mixins: [orderMixin, scrollMixin],

  components: {
    Payment,
    Wirecard,
    Success,
    Error,
    CouponCard
  },

  data() {
    return {
      order: null,
      payment_callback: false
    };
  },

  methods: {
    ...mapActions("orders", ["getOrder"]),
    ...mapActions("newOrder", ["applyProfessionalBeginnerCoupon"]),

    setPaymentCallback(callback) {
      if (callback === "clear") return (this.payment_callback = false);
      this.payment_callback = callback ? "success" : "error";
      this.scrollTo("body");
    },

    async setOrder() {
      try {
        let order = await this.getOrder(this.$route.params.order_id);

        if (!this.canGoToCheckout(order))
          this.$router.push({
            name: "order",
            params: { order_id: this.$route.params.order_id }
          });
        else this.order = order;
      } catch (e) {
        this.$toasted.error(e);
      }
    },

    purpleWeekCoupon(coupon) {
      const purpleWeekCoupons = [
        "TERCAROXA5",
        "QUARTAROXA7",
        "QUINTAROXA7",
        "SEXTAROXA10"
      ];

      return purpleWeekCoupons.includes(coupon.toUpperCase());
    }
  },

  computed: {
    couponName() {
      return this.order != undefined && this.order.coupon != undefined
        ? this.order.coupon.name
        : "";
    }
  },

  async mounted() {
    await this.setOrder();
  }
};
</script>

<template>
  <div v-if="order">
    <div class="container">
      <div class="row">
        <div class="left holder">
          <div
            class="card coupon-card mr-0 ml-10"
            v-if="payment_callback === 'success' && purpleWeekCoupon(couponName)"
          >
            <transition name="zoom" mode="out-in">
              <coupon-card
                :couponName="couponName"
              />
            </transition>
          </div>

          <div class="card">
            <transition name="zoom" mode="out-in">
              <success v-if="payment_callback === 'success'" :payable="order" />
              <error v-else-if="payment_callback === 'error'" @clear="setPaymentCallback('clear')" />
              <payment
                v-else
                @paymentCallback="setPaymentCallback"
                @refresh="setOrder"
                :payable="order"
              />
            </transition>
          </div>
        </div>

        <div class="right holder">
          <Wirecard />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.left {
  width: 70%;
  margin-right: 10px;
}

.right {
  width: calc(30% - 10px);
}

.coupon-card {
  background: #391a52;
}

@media (max-width: 992px) {
  .left,
  .right {
    width: 100%;
  }

  .row {
    flex-direction: column !important;
  }
}

@media (max-width: 540px) {
  .right {
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Index.vue